import { render, staticRenderFns } from "./DeTabs.vue?vue&type=template&id=314bd99e&scoped=true&"
import script from "./DeTabs.vue?vue&type=script&lang=js&"
export * from "./DeTabs.vue?vue&type=script&lang=js&"
import style0 from "./DeTabs.vue?vue&type=style&index=0&id=314bd99e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314bd99e",
  null
  
)

export default component.exports